import { useState, useEffect } from 'react';
import orderApi from 'src/api/OrderApi';
import { POHistoryHeader } from 'src/types/poHistory';

export const usePOHistory = (orderNumber: number | string | undefined) => {
  const [poHistory, setPOHistory] = useState<POHistoryHeader[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!orderNumber) {
      setPOHistory([]);
      return;
    }

    console.log('usePOHistory request', { orderNumber });

    setIsLoading(true);
    orderApi
      .getPOHistory(orderNumber.toString())
      .then((response) => {
        console.log('getPOHistory raw response', response);
        const history = response?.history || [];
        setPOHistory(history);
        setError(null);
      })
      .catch((err) => {
        setPOHistory([]);
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [orderNumber]);

  return { poHistory, isLoading, error };
};
